<template>
    <div v-loading="loading">
        <hts-form-date
            v-model="filters.dateRange"
            range
            type="dateRange"
            prop="dateRange"
            :placeholder="$t('labels.fromTo')"
            class="max-w-96 max-h-96" />
        <div class="my-4">
            <h2>
                {{ $t('labels.route2') }}
            </h2>
            <hts-data-table
                class="w-full mt-4"
                :headers="headers"
                :items="items || []" />
        </div>
    </div>
</template>

<script setup lang="ts">
const { $formatters } = useNuxtApp()
const { reportPage } = $store()
const loading = ref(true)

const headers = [
  {
    field: 'routeName',
    headerName: $t('labels.route2')
  },
  {
    field: 'totalRun',
    headerName: $t('labels.totalRun'),
    valueGetter: (params: any) => {
      const { totalRun } = params.data
      return `${$formatters.formatNumber(totalRun || 0)}`
    }
  },
  {
    field: 'estimatedAverageRunTime',
    headerName: $t('labels.estimatedAverageRunTime'),
    valueGetter: (params: any) => {
      const { estimatedAverageRunTime } = params.data
      return `${$formatters.convertMinutesToNaturalLanguage(estimatedAverageRunTime || 0, 'second')}`
    }
  },
  {
    field: 'actualAverageRunTime',
    headerName: $t('labels.actualAverageRunTime'),
    valueGetter: (params: any) => {
      const { actualAverageRunTime } = params.data
      return `${$formatters.convertMinutesToNaturalLanguage(actualAverageRunTime || 0, 'second')}`
    }
  }
]

const items = ref<any[]>([])

const filters = computed({
  get () {
    return reportPage.filters
  },
  set (val: any) {
    reportPage.setFilters(val)
  }
})

onMounted(() => {
  getReport()
})

/** Watching */
watch(
  () => filters.value,
  (val: any) => {
    loadReport()
  },
  { deep: true }
)

/** API requests */
const getReport = () => {
  items.value = []
  $api($url.report.getRoute, { body: filters.value })
    .then((data: any) => {
      const responseData: any = data.data.value
      if (responseData?.success) {
        items.value = responseData.data
      } else {
        items.value = []
      }
      loading.value = false
    })
    .catch(() => {
      loading.value = false
    })
}

const loadReport = $lodash.debounce(getReport, 500)
</script>
